import { render } from "./PaiementAutreRecettes.vue?vue&type=template&id=5d23e416&ts=true"
import script from "./PaiementAutreRecettes.vue?vue&type=script&lang=ts"
export * from "./PaiementAutreRecettes.vue?vue&type=script&lang=ts"

import "./PaiementAutreRecettes.vue?vue&type=style&index=0&id=5d23e416&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__